import Navigation from "./partials/navigation";
import EventCalendar from "./partials/event-calendar";
import HeaderWidthNavigation from "./partials/header-width-navigation";
import Gallery from "./partials/gallery";
import GalleryLightboxes from "./partials/gallery-lightboxes";
import Animate from "./partials/animate";
import Form from "./partials/form";
import Video from "./partials/video";
import RecaptchaHandler from "./partials/builder-recaptcha";
import Collapsable from "./partials/collapsable";
import Modal from './partials/modals';
import GLightbox from '../../../../assets/vendor/glightbox/glightbox.min.js';
import ProductionRunCalendar from "./partials/production-run-calendar";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-metrics-cat="eventCalendarV2"],[data-block-type="event-calendar-block"],[data-block-type="event-calendar-block-for-ticket-winner-flow"]').forEach($element => (new EventCalendar($element)));
    $wrapper.querySelectorAll('[data-header-width-navigation-slider]').forEach($element => (new HeaderWidthNavigation($element)));
    $wrapper.querySelectorAll('[data-navigation]').forEach($element => (new Navigation($element)));
    $wrapper.querySelectorAll('[data-gallery]').forEach($element => (new Gallery($element)));
    $wrapper.querySelectorAll('[data-gallery-lightboxes]').forEach($element => (new GalleryLightboxes($element)));
    $wrapper.querySelectorAll('[data-animate]').forEach($element => (new Animate($element)));
    $wrapper.querySelectorAll('.form:not([data-no-recaptcha])').forEach($element => (new RecaptchaHandler($element)));
    $wrapper.querySelectorAll('[data-form]').forEach($element => (new Form($element)));
    $wrapper.querySelectorAll('[data-videoplayer]').forEach($element => (new Video($element)));
    $wrapper.querySelectorAll('[data-modal]').forEach( $modal => (new Modal($modal)));
    $wrapper.querySelectorAll('.collapsable-trigger').forEach($element => (new Collapsable($element)));
    $wrapper.querySelectorAll('[data-dropdown]').forEach(async $element => {
        const Dropdown = await import('./partials/dropdown.js');
        (new Dropdown.default($element));
    });
    $wrapper.querySelectorAll('[data-block-type="production-run-calendar"]').forEach(async $calendar => {
        const ProductionRunCalendar = await import('./partials/production-run-calendar.js');
        (new ProductionRunCalendar.default($calendar));
    });


    new GLightbox({
        selector : '[data-lightbox-gallery]',
    });

    /**
     * Wrap videos in reading in video container
     */
    $wrapper.querySelectorAll('.reading iframe[src*="youtube.com"], .reading iframe[data-cmp-src*="youtube.com"]').forEach(($el) => {
        if (!$el.parentElement.classList.contains('.video-container') && !$el.parentElement.classList.contains('.embed-container')) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('video-container')
            $el.parentNode.insertBefore(wrapper, $el);
            wrapper.appendChild($el);
        }
    });

    /**
     * Wrap tables in reading in tale container
     */
    $wrapper.querySelectorAll('.reading table').forEach(($el) => {
        if (!$el.parentElement.classList.contains('.table-container')) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('table-container')
            $el.parentNode.insertBefore(wrapper, $el);
            wrapper.appendChild($el);
        }
    });
}

(function() {
    window.initDom(document);
})();